(function () {
  'use strict';

  function stripHtml(str) {
    if (!str) return '';
    return String(str).replace(/<[^>]*>/g, '').trim();
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = 0;
    const value = (cents / 100).toFixed(2);
    const amount = Math.floor(cents / 100);
    const amountNoDecimals = String(amount);
    const amountWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amountWithSpace = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    format = stripHtml(format);
    if (!format) return amountWithComma;

    return stripHtml(
      format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, amountWithSpace)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, value)
    );
  }

  function simpleConfetti(canvas, duration) {
    if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const ctx = canvas.getContext('2d');
    const particles = [];
    const colors = ['#c41e3a', '#c9a227', '#0a0a0a', '#ffffff', '#e8354f'];
    const w = (canvas.width = window.innerWidth);
    const h = (canvas.height = window.innerHeight);

    for (let i = 0; i < 120; i++) {
      particles.push({
        x: w * 0.5 + (Math.random() - 0.5) * 200,
        y: h * 0.4,
        vx: (Math.random() - 0.5) * 14,
        vy: Math.random() * -12 - 4,
        size: Math.random() * 8 + 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rot: Math.random() * 360,
        vr: (Math.random() - 0.5) * 12,
        life: 1
      });
    }

    const start = performance.now();

    function frame(now) {
      const elapsed = now - start;
      ctx.clearRect(0, 0, w, h);

      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.35;
        p.rot += p.vr;
        p.life = Math.max(0, 1 - elapsed / duration);

        ctx.save();
        ctx.globalAlpha = p.life;
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rot * Math.PI) / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      });

      if (elapsed < duration) {
        requestAnimationFrame(frame);
      } else {
        ctx.clearRect(0, 0, w, h);
      }
    }

    requestAnimationFrame(frame);
  }

  class BundleBuilder {
    constructor(root, data) {
      this.root = root;
      this.data = data;
      this.state = {
        bundleId: this._uuid(),
        items: [],
        giftVariantId: null,
        giftSize: null,
        unlocked: false,
        hasCelebrated: false,
        activeFilter: 'all'
      };

      this.els = {
        progress: root.querySelector('[data-appe-bundle-progress]'),
        progressCount: root.querySelector('[data-appe-bundle-count]'),
        progressValue: root.querySelector('[data-appe-bundle-value]'),
        progressMessage: root.querySelector('[data-appe-bundle-progress-msg]'),
        progressBar: root.querySelector('[data-appe-bundle-progress-bar]'),
        progressLive: root.querySelector('[data-appe-bundle-live]'),
        grid: root.querySelector('[data-appe-bundle-grid]'),
        filters: root.querySelector('[data-appe-bundle-filters]'),
        summary: root.querySelector('[data-appe-bundle-summary]'),
        summaryItems: root.querySelector('[data-appe-bundle-summary-items]'),
        summaryEmpty: root.querySelector('[data-appe-bundle-summary-empty]'),
        summaryCount: root.querySelector('[data-appe-bundle-summary-count]'),
        summarySubtotal: root.querySelector('[data-appe-bundle-summary-subtotal]'),
        summaryMiniBar: root.querySelector('[data-appe-bundle-mini-bar]'),
        reward: root.querySelector('[data-appe-bundle-reward]'),
        rewardError: root.querySelector('[data-appe-bundle-size-error]'),
        unlock: root.querySelector('[data-appe-bundle-unlock]'),
        unlockClose: root.querySelector('[data-appe-bundle-unlock-close]'),
        confetti: root.querySelector('[data-appe-bundle-confetti]'),
        addBtn: root.querySelector('[data-appe-bundle-add-cart]'),
        buyBtn: root.querySelector('[data-appe-bundle-buy-now]'),
        ctaHint: root.querySelector('[data-appe-bundle-cta-hint]'),
        mobileToggle: root.querySelector('[data-appe-bundle-mobile-toggle]'),
        mobileCount: root.querySelector('[data-appe-bundle-mobile-count]'),
        mobileSubtotal: root.querySelector('[data-appe-bundle-mobile-subtotal]')
      };

      this.productMap = {};
      data.products.forEach((p) => {
        this.productMap[p.id] = p;
      });

      this._bindEvents();
      this.render();
    }

    _uuid() {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
      }
      return 'bundle-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    }

    _bindEvents() {
      const self = this;

      this.root.addEventListener('click', (e) => {
        const filterBtn = e.target.closest('[data-appe-bundle-filter]');
        if (filterBtn) {
          e.preventDefault();
          self.setFilter(filterBtn.dataset.appeBundleFilter);
          return;
        }

        const addBtn = e.target.closest('[data-appe-bundle-add]');
        if (addBtn) {
          e.preventDefault();
          const card = addBtn.closest('[data-appe-bundle-card]');
          if (card) self.toggleProduct(card);
          return;
        }

        const qtyBtn = e.target.closest('[data-appe-bundle-summary-qty-btn]');
        if (qtyBtn) {
          e.preventDefault();
          const variantId = parseInt(qtyBtn.dataset.variantId, 10);
          const row = qtyBtn.closest('[data-appe-bundle-summary-item]');
          const input = row?.querySelector('[data-appe-bundle-summary-qty-input]');
          let val = parseInt(input?.value, 10) || 1;
          if (qtyBtn.dataset.action === 'plus') val++;
          else val = Math.max(1, val - 1);
          if (input) input.value = val;
          self.setQty(variantId, val);
          return;
        }

        const removeBtn = e.target.closest('[data-appe-bundle-remove]');
        if (removeBtn) {
          e.preventDefault();
          self.removeItem(parseInt(removeBtn.dataset.variantId, 10));
          return;
        }

        if (e.target.closest('[data-appe-bundle-add-cart]')) {
          e.preventDefault();
          self.addToCart({ buyNow: false });
          return;
        }

        if (e.target.closest('[data-appe-bundle-buy-now]')) {
          e.preventDefault();
          self.addToCart({ buyNow: true });
          return;
        }

        if (e.target.closest('[data-appe-bundle-unlock-close]')) {
          e.preventDefault();
          self.closeUnlock();
          return;
        }

        if (e.target.closest('[data-appe-bundle-mobile-toggle]')) {
          e.preventDefault();
          self.els.summary.classList.toggle('is-expanded');
          const expanded = self.els.summary.classList.contains('is-expanded');
          if (self.els.mobileToggle) {
            self.els.mobileToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          }
        }
      });

      this.root.addEventListener('change', (e) => {
        if (e.target.matches('[data-appe-bundle-variant]')) {
          const card = e.target.closest('[data-appe-bundle-card]');
          const productId = parseInt(card.dataset.productId, 10);
          const oldVariantId = card.dataset.selectedVariantId
            ? parseInt(card.dataset.selectedVariantId, 10)
            : null;
          const newVariantId = parseInt(e.target.value, 10);
          card.dataset.selectedVariantId = newVariantId;
          self._updateCardPrice(card, newVariantId);

          if (oldVariantId) {
            const idx = self.state.items.findIndex((i) => i.variantId === oldVariantId);
            if (idx > -1) {
              const qty = self.state.items[idx].qty;
              self.state.items.splice(idx, 1);
              self.addItem(newVariantId, productId, qty);
            }
          }
        }

        if (e.target.matches('[data-appe-bundle-summary-qty-input]')) {
          const variantId = parseInt(e.target.dataset.variantId, 10);
          let val = parseInt(e.target.value, 10) || 1;
          val = Math.max(1, Math.min(99, val));
          e.target.value = val;
          self.setQty(variantId, val);
        }

        if (e.target.matches('[data-appe-bundle-size]')) {
          self.selectGiftSize(e.target.value);
        }
      });

      if (this.els.unlock) {
        this.els.unlock.addEventListener('click', (e) => {
          if (e.target === self.els.unlock) self.closeUnlock();
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && self.els.unlock?.classList.contains('is-active')) {
          self.closeUnlock();
        }
      });
    }

    _getCardVariantId(card) {
      const select = card.querySelector('[data-appe-bundle-variant]');
      if (select) return parseInt(select.value, 10);
      const hidden = card.querySelector('[data-appe-bundle-variant-id]');
      return parseInt(hidden.value, 10);
    }

    _updateCardPrice(card, variantId) {
      const productId = parseInt(card.dataset.productId, 10);
      const product = this.productMap[productId];
      const variant = product.variants.find((v) => v.id === variantId);
      if (!variant) return;
      const priceEl = card.querySelector('[data-appe-bundle-card-price]');
      if (priceEl) {
        priceEl.innerHTML = this._priceHtml(variant.price, variant.compare_at_price);
      }
    }

    _priceHtml(price, compareAt) {
      const fmt = this.data.moneyFormat;
      if (compareAt && compareAt > price) {
        return `<del>${formatMoney(compareAt, fmt)}</del> <ins>${formatMoney(price, fmt)}</ins>`;
      }
      return formatMoney(price, fmt);
    }

    setFilter(handle) {
      this.state.activeFilter = handle;
      this.els.filters.querySelectorAll('[data-appe-bundle-filter]').forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.appeBundleFilter === handle);
      });

      this.root.querySelectorAll('[data-appe-bundle-card]').forEach((card) => {
        const collections = (card.dataset.collections || '').split(',');
        const show = handle === 'all' || collections.includes(handle);
        card.classList.toggle('is-hidden', !show);
      });
    }

    toggleProduct(card) {
      const productId = parseInt(card.dataset.productId, 10);
      const variantId = this._getCardVariantId(card);
      const existing = this.state.items.find((i) => i.variantId === variantId);

      if (existing) {
        this.removeItem(variantId);
      } else {
        this.addItem(variantId, productId, 1);
        if (window.innerWidth < 990 && this.els.summary) {
          this.els.summary.classList.add('is-expanded');
        }
      }
    }

    addItem(variantId, productId, qty) {
      const product = this.productMap[productId];
      if (!product) return;

      const variant = product.variants.find((v) => v.id === variantId);
      if (!variant || !variant.available) return;

      const existing = this.state.items.find((i) => i.variantId === variantId);
      if (existing) {
        existing.qty = qty;
      } else {
        this.state.items.push({
          variantId,
          productId,
          title: product.title + (variant.title !== 'Default Title' ? ' — ' + variant.title : ''),
          price: variant.price,
          qty,
          image: variant.image || product.featured_image
        });
      }

      this.render();
    }

    removeItem(variantId) {
      this.state.items = this.state.items.filter((i) => i.variantId !== variantId);
      this.render();
    }

    setQty(variantId, qty) {
      const item = this.state.items.find((i) => i.variantId === variantId);
      if (item) {
        item.qty = Math.max(1, qty);
        this.render();
      }
    }

    getProductCount() {
      return this.state.items.reduce((s, i) => s + i.qty, 0);
    }

    getSubtotalCents() {
      return this.state.items.reduce((s, i) => s + i.price * i.qty, 0);
    }

    checkUnlock() {
      return (
        this.getProductCount() >= this.data.minProducts &&
        this.getSubtotalCents() >= this.data.minValue
      );
    }

    selectGiftSize(size) {
      const variants = this.data.giftProduct?.variants || {};
      const variantId = variants[size];
      if (!variantId) return;

      this.state.giftSize = size;
      this.state.giftVariantId = variantId;
      if (this.els.rewardError) {
        this.els.rewardError.classList.remove('is-visible');
      }
      this._updateCtas();
    }

    canCheckout() {
      const count = this.getProductCount();
      const subtotal = this.getSubtotalCents();

      if (count < this.data.minProducts) {
        return { ok: false, reason: 'min_products', message: this.data.strings.needMoreProducts };
      }
      if (subtotal < this.data.minValue) {
        return { ok: false, reason: 'min_value', message: this.data.strings.needMoreValue };
      }
      if ( this.state.unlocked && this.data.giftProduct.requiresSize && !this.state.giftVariantId ) {
        return { ok: false, reason: 'size_required', message: this.data.strings.selectSize };
      }
      return { ok: true };
    }

    buildCartPayload() {
      const props = { _bundle_id: this.state.bundleId, _bundle_builder: 'appe' };
      const lines = this.state.items.map((i) => ({
        id: i.variantId,
        quantity: i.qty,
        properties: { ...props }
      }));

      const giftId = this.state.giftVariantId || Object.values(this.data.giftProduct.variants).find(Boolean); if (this.state.unlocked && giftId) {
        lines.push({
          id: giftId,
          quantity: 1,
          properties: {
            ...props,
            _bundle_gift: 'true',
            Size: this.state.giftSize
          }
        });
      }

      return { items: lines };
    }

    async addToCart({ buyNow }) {
      const check = this.canCheckout();
      if (!check.ok) {
        if (check.reason === 'size_required' && this.els.rewardError) {
          this.els.rewardError.classList.add('is-visible');
        }
        if (this.els.ctaHint) this.els.ctaHint.textContent = check.message;
        return;
      }

      const btn = buyNow ? this.els.buyBtn : this.els.addBtn;
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = this.data.strings.adding;

      try {
        const url =
          (window.T4Sroutes && window.T4Sroutes.cart_add_url) || '/cart/add.js';
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(this.buildCartPayload())
        });

        const result = await res.json();

        if (!res.ok) {
          throw new Error(result.description || result.message || 'Cart error');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        if (buyNow) {
          window.location.href = '/checkout';
          return;
        }

        const cartLink = document.querySelector(
          '[data-drawer-options*="t4s-mini_cart"]'
        );
        if (cartLink) cartLink.click();

        if (this.els.ctaHint) {
          this.els.ctaHint.textContent = this.data.strings.added;
        }
      } catch (err) {
        if (this.els.ctaHint) {
          this.els.ctaHint.textContent = err.message;
        }
      } finally {
        btn.disabled = false;
        btn.textContent = originalText;
        this._updateCtas();
      }
    }

    showUnlock() {
      if (!this.els.unlock) return;
      this.els.unlock.classList.add('is-active');
      this.els.unlock.setAttribute('aria-hidden', 'false');
      simpleConfetti(this.els.confetti, 2800);

      if (this.data.enableSound) {
        const audio = this.root.querySelector('[data-appe-bundle-sound]');
        if (audio) {
          audio.currentTime = 0;
          audio.play().catch(() => {});
        }
      }
    }

    closeUnlock() {
      if (!this.els.unlock) return;
      this.els.unlock.classList.remove('is-active');
      this.els.unlock.setAttribute('aria-hidden', 'true');
    }

    render() {
      const count = this.getProductCount();
      const subtotal = this.getSubtotalCents();
      const minProducts = this.data.minProducts;
      const minValue = this.data.minValue;
      const wasUnlocked = this.state.unlocked;
      this.state.unlocked = this.checkUnlock();

      const countPct = Math.min(100, (count / minProducts) * 100);
      const valuePct = Math.min(100, (subtotal / minValue) * 100);
      const progressPct = Math.min(countPct, valuePct);

      const remaining = Math.max(0, minValue - subtotal);
      const productsNeeded = Math.max(0, minProducts - count);

      if (this.els.progressCount) {
        this.els.progressCount.textContent = `${count}/${minProducts}`;
      }
      if (this.els.progressValue) {
        this.els.progressValue.textContent = `${formatMoney(subtotal, this.data.moneyFormat)} / ${formatMoney(minValue, this.data.moneyFormat)}`;
      }
      if (this.els.progressBar) {
        this.els.progressBar.style.width = progressPct + '%';
        const track = this.els.progressBar.parentElement;
        if (track) track.setAttribute('aria-valuenow', Math.round(progressPct));
      }
      if (this.els.progressMessage) {
        if (this.state.unlocked) {
          this.els.progressMessage.textContent = this.data.strings.unlocked;
          this.els.progressMessage.classList.add('is-unlocked');
        } else {
          const parts = [];
          if (productsNeeded > 0) {
            parts.push(
              this.data.strings.productsLeft.replace('[count]', productsNeeded)
            );
          }
          if (remaining > 0) {
            parts.push(
              this.data.strings.valueLeft.replace(
                '[amount]',
                formatMoney(remaining, this.data.moneyFormat)
              )
            );
          }
          this.els.progressMessage.textContent =
            parts.join(' · ') || this.data.strings.keepBuilding;
          this.els.progressMessage.classList.remove('is-unlocked');
        }
      }
      if (this.els.progressLive) {
        this.els.progressLive.textContent = `${count} products, ${formatMoney(subtotal, this.data.moneyFormat)}`;
      }

      if (this.els.summaryMiniBar) {
        this.els.summaryMiniBar.style.width = progressPct + '%';
      }
      if (this.els.summaryCount) {
        this.els.summaryCount.textContent = String(count);
      }
      if (this.els.summarySubtotal) {
        this.els.summarySubtotal.textContent = formatMoney(
          subtotal,
          this.data.moneyFormat
        );
      }
      if (this.els.mobileCount) {
        this.els.mobileCount.textContent = `${count} ${this.data.strings.items}`;
      }
      if (this.els.mobileSubtotal) {
        this.els.mobileSubtotal.textContent = formatMoney(
          subtotal,
          this.data.moneyFormat
        );
      }

      this._renderSummaryItems();
      this._renderCardStates();
      this._renderReward();

      if (this.state.unlocked && !wasUnlocked) {
        if (!this.state.hasCelebrated) {
          this.state.hasCelebrated = true;
          this.showUnlock();
        }
      }

      if (!this.state.unlocked) {
        this.state.giftVariantId = null;
        this.state.giftSize = null;
        this.state.hasCelebrated = false;
      }

      this._updateCtas();
    }

    _renderSummaryItems() {
      if (!this.els.summaryItems) return;

      if (this.state.items.length === 0) {
        this.els.summaryItems.innerHTML = '';
        if (this.els.summaryEmpty) this.els.summaryEmpty.style.display = '';
        return;
      }

      if (this.els.summaryEmpty) this.els.summaryEmpty.style.display = 'none';

      this.els.summaryItems.innerHTML = this.state.items
        .map(
          (item) => `
        <div class="appe-bundle-summary__item" data-appe-bundle-summary-item data-variant-id="${item.variantId}">
          <img class="appe-bundle-summary__thumb" src="${item.image}" alt="" width="52" height="52" loading="lazy">
          <div class="appe-bundle-summary__item-info">
            <p class="appe-bundle-summary__item-title">${this._escape(item.title)}</p>
            <div class="appe-bundle-summary__qty">
              <button type="button" class="appe-bundle-summary__qty-btn" data-appe-bundle-summary-qty-btn data-action="minus" data-variant-id="${item.variantId}" aria-label="Decrease quantity">−</button>
              <input type="number" class="appe-bundle-summary__qty-input" data-appe-bundle-summary-qty-input data-variant-id="${item.variantId}" value="${item.qty}" min="1" max="99" aria-label="Quantity">
              <button type="button" class="appe-bundle-summary__qty-btn" data-appe-bundle-summary-qty-btn data-action="plus" data-variant-id="${item.variantId}" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <div class="appe-bundle-summary__item-actions">
            <span class="appe-bundle-summary__item-price">${formatMoney(item.price * item.qty, this.data.moneyFormat)}</span>
            <button type="button" class="appe-bundle-summary__remove" data-appe-bundle-remove data-variant-id="${item.variantId}">${this.data.strings.remove}</button>
          </div>
        </div>`
        )
        .join('');

      if (this.state.unlocked && this.state.giftSize) {
        const gift = this.data.giftProduct;
        this.els.summaryItems.innerHTML += `
          <div class="appe-bundle-summary__item">
            <img class="appe-bundle-summary__thumb" src="${gift.image}" alt="" width="52" height="52" loading="lazy">
            <div class="appe-bundle-summary__item-info">
              <p class="appe-bundle-summary__item-title">${this._escape(gift.title)}</p>
              <span class="appe-bundle-summary__item-meta">${this.data.strings.freeGift} · ${this.state.giftSize}</span>
            </div>
            <div class="appe-bundle-summary__item-actions">
              <span class="appe-bundle-summary__item-price">${this.data.strings.free}</span>
            </div>
          </div>`;
      }
    }

    _renderCardStates() {
      const selectedIds = new Set(this.state.items.map((i) => i.variantId));

      this.root.querySelectorAll('[data-appe-bundle-card]').forEach((card) => {
        const variantId = this._getCardVariantId(card);
        const isSelected = selectedIds.has(variantId);
        card.classList.toggle('is-selected', isSelected);

        const btn = card.querySelector('[data-appe-bundle-add]');
        if (btn) {
          btn.textContent = isSelected
            ? this.data.strings.inBundle
            : this.data.strings.addToBundle;
        }
      });
    }

    _renderReward() {
      if (!this.els.reward) return;

      this.els.reward.classList.toggle('is-visible', this.state.unlocked);

      const sizes = this.data.giftProduct?.variantMeta || {};
      this.root.querySelectorAll('[data-appe-bundle-size]').forEach((input) => {
        const wrap = input.closest('.appe-bundle-reward__size');
        const meta = sizes[input.value];
        const disabled = !meta || !meta.available;
        input.disabled = disabled;
        if (wrap) wrap.classList.toggle('is-disabled', disabled);
        if (disabled && input.checked) {
          input.checked = false;
          this.state.giftVariantId = null;
          this.state.giftSize = null;
        }
      });
    }

    _updateCtas() {
      const check = this.canCheckout();
      const hasItems = this.state.items.length > 0;

      if (this.els.addBtn) this.els.addBtn.disabled = !check.ok || !hasItems;
      if (this.els.buyBtn) this.els.buyBtn.disabled = !check.ok || !hasItems;

      if (this.els.ctaHint && check.ok) {
        this.els.ctaHint.textContent = '';
      } else if (this.els.ctaHint && !check.ok && hasItems) {
        this.els.ctaHint.textContent = check.message;
      }
    }

    _escape(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  }

  function init() {
    document.querySelectorAll('[data-appe-bundle-root]').forEach((root) => {
      const dataEl = root.querySelector('[data-appe-bundle-json]');
      if (!dataEl) return;
      try {
        const data = JSON.parse(dataEl.textContent);
        new BundleBuilder(root, data);
      } catch (e) {
        console.error('Bundle Builder init error:', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();